import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import {
  Box,
  Button,
  Typography,
  InputLabel,
  Select,
  MenuItem,
  Chip,
} from "@mui/material";
import style from "./style";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const CustomerStatement = ({ customerList }) => {
  const [filters, setFilters] = useState({
    customer: "",
    type: "",
    startDate: null,
    endDate: null,
  });

  const [filteredData, setFilteredData] = useState(null);

  const handleChange = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const getInvoiceStatus = (invoice) => {
    const paid = parseFloat(invoice.paid.replace("$", ""));
    const total = parseFloat(invoice.total.replace("$", ""));
    const dueDate = new Date(invoice.due);
    const today = new Date();

    if (paid >= total) return "Paid";
    if (dueDate < today) return "Overdue";
    return "Pending";
  };

  const getChipColor = (status) => {
    switch (status) {
      case "Paid":
        return "success";
      case "Pending":
        return "warning";
      case "Overdue":
        return "error";
      default:
        return "default";
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Mock filtered result:
    const selectedCustomer = customerList.find(
      (c) => c._id === filters.customer
    );

    const mockData = {
      customer: selectedCustomer?.name || "Test Customer",
      email: selectedCustomer?.email || "hello@thetechagency.com",
      address: selectedCustomer?.billingAddress
        ? `${selectedCustomer.billingAddress?.street1}, ${selectedCustomer.billingAddress?.street2}, ${selectedCustomer.billingAddress?.city}, ${selectedCustomer.billingAddress?.country}, ${selectedCustomer.billingAddress?.pinCode}`
        : "Global Technologies 5754 Airport Rd, Coosada, AL, 36020 United States",
      phone: selectedCustomer?.billingAddress?.phone || "888-777-6655",
      type: filters.type || "Outstanding Invoice",
      duration: "April 2024 to Nov 2024",
      invoices: [
        {
          id: 1,
          number: "Invoice330",
          date: "Apr 26, 2024",
          due: "Apr 30, 2024",
          total: "$3470",
          paid: "$1270",
          dueAmount: "$2270",
        },
        {
          id: 2,
          number: "Invoice331",
          date: "May 4, 2024",
          due: "May 14, 2024",
          total: "$3470",
          paid: "$1270",
          dueAmount: "$2270",
        },
        {
          id: 3,
          number: "Invoice332",
          date: "Jul 1, 2024",
          due: "Jul 20, 2024",
          total: "$2000",
          paid: "$2000",
          dueAmount: "$0",
        },
      ],
      subtotal: "$5270",
      received: "$2270",
      dueTotal: "$3000",
      total: "$3000",
    };

    setFilteredData(mockData);

    // Clear form
    setFilters({
      customer: "",
      type: "",
      startDate: null,
      endDate: null,
    });
  };

  return (
    <>
      <Box px="15px" mt={2}>
        <Box sx={style.headerContainer}>
          <Typography sx={style.leaveHeading}>Customer Statement</Typography>
        </Box>
      </Box>

      <Grid container sx={style.mainContainer}>
        <Grid item xs={12} lg={11.8} sx={style.gridbox}>
          <Box component="form" onSubmit={handleSubmit}>
            <Box sx={style.inputSection}>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>Customer</Typography>
                <Select
                  value={filters.customer}
                  onChange={(e) => handleChange("customer", e.target.value)}
                  name="customer"
                  sx={style.dropdown}
                >
                  {customerList.map(({ _id, name }) => (
                    <MenuItem sx={style.dropDownMenu} key={_id} value={_id}>
                      {name}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>Type</Typography>
                <Select
                  value={filters.type}
                  onChange={(e) => handleChange("type", e.target.value)}
                  name="type"
                  sx={style.dropdown}
                >
                  <MenuItem sx={style.dropDownMenu} value="Outstanding">
                    Outstanding Invoice
                  </MenuItem>
                  <MenuItem sx={style.dropDownMenu} value="Paid">
                    Paid Invoice
                  </MenuItem>
                </Select>{" "}
              </Box>

              <Box sx={style.inputBox}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <InputLabel sx={style.label}>Start Month</InputLabel>
                  <DatePicker
                    value={filters.startDate}
                    onChange={(newValue) => handleChange("startDate", newValue)}
                    sx={style.dateInput}
                    slotProps={{
                      field: {
                        readOnly: true,
                      },
                    }}
                  />
                </LocalizationProvider>
              </Box>
              <Box sx={style.inputBox}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <InputLabel sx={style.label}>End Month</InputLabel>
                  <DatePicker
                    value={filters.endDate}
                    onChange={(newValue) => handleChange("endDate", newValue)}
                    sx={style.dateInput}
                    slotProps={{
                      field: {
                        readOnly: true,
                      },
                    }}
                  />
                </LocalizationProvider>{" "}
              </Box>

              <Box sx={style.createJob}>
                <Button
                  variant="contained"
                  type="submit"
                  color="success"
                  sx={style.jobButtons}
                >
                  Apply Filter
                </Button>
              </Box>
            </Box>
          </Box>
        </Grid>

        {filteredData && (
          <>
            <Grid container spacing={2} px="15px" mt={1}>
              <Grid item md={4} xs={12}>
                <Box sx={style.card}>
                  <Box>
                    <Typography sx={style.textHeading}>Customer</Typography>{" "}
                    <Typography sx={style.textBody}>
                      {filteredData.customer}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item md={4} xs={12}>
                <Box sx={style.card}>
                  <Box>
                    <Typography sx={style.textHeading}>Type</Typography>{" "}
                    <Typography sx={style.textBody}>
                      {filteredData.type}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item md={4} xs={12}>
                <Box sx={style.card}>
                  <Box>
                    <Typography sx={style.textHeading}>Duration</Typography>{" "}
                    <Typography sx={style.textBody}>
                      {filteredData.duration}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>

            <Grid container spacing={2} px="15px">
              <Grid item md={12} xs={12}>
                <Box sx={style.cards}>
                  <Box>
                    <Typography sx={style.BillHeading}>Bill To:</Typography>
                    <Typography sx={style.techHeading}>
                      {filteredData.customer}
                    </Typography>
                    <Typography sx={style.textinfo}>
                      {filteredData.email}
                    </Typography>
                    <Typography sx={style.textinfo}>
                      {filteredData.address}
                    </Typography>
                    <Typography sx={style.textinfo}>
                      {filteredData.phone}
                    </Typography>
                  </Box>
                  <Box sx={style.tableSection}>
                    <Typography sx={style.TableHead}>
                      Product or Service
                    </Typography>
                    <TableContainer>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell sx={style.TableHead}>#</TableCell>
                            <TableCell sx={style.TableHead}>
                              Invoice No.
                            </TableCell>
                            <TableCell sx={style.TableHead}>
                              Invoice Date
                            </TableCell>
                            <TableCell sx={style.TableHead}>Due Date</TableCell>
                            <TableCell sx={style.TableHead}>Total</TableCell>
                            <TableCell sx={style.TableHead}>Paid</TableCell>
                            <TableCell sx={style.TableHead}>Due</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {filteredData.invoices.map((inv) => {
                            const status = getInvoiceStatus(inv);
                            console.log(
                              "🚀 ~ {filteredData.invoices.map ~ status ==> ",
                              status
                            );
                            return (
                              <TableRow key={inv.id}>
                                <TableCell sx={style.tabledata}>
                                  {inv.id}
                                </TableCell>
                                <TableCell sx={style.tabledata}>
                                  {inv.number}
                                </TableCell>
                                <TableCell sx={style.tabledata}>
                                  {inv.date}
                                </TableCell>
                                <TableCell sx={style.tabledata}>
                                  <Box sx={{display: "flex", gap: 1}}>
                                    <Typography>{inv.due}</Typography>
                                    <Chip
                                      label={status}
                                      color={getChipColor(status)}
                                      variant="contained"
                                      size="small"
                                      sx={{ fontWeight: 400 }}
                                    />
                                  </Box>
                                </TableCell>
                                <TableCell sx={style.tabledata}>
                                  {inv.total}
                                </TableCell>
                                <TableCell sx={style.tabledata}>
                                  {inv.paid}
                                </TableCell>
                                <TableCell sx={style.tabledata}>
                                  {inv.dueAmount}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                  <Box sx={style.totalSection}>
                    <Box sx={style.line}></Box>
                    <Typography sx={style.subTotals}>
                      Subtotal: {filteredData.subtotal}
                    </Typography>
                    <Typography sx={style.subTotal}>
                      Received amount: {filteredData.received}
                    </Typography>
                    <Typography sx={style.subTotal}>
                      Due amount: {filteredData.dueTotal}
                    </Typography>
                    <Typography sx={style.total}>
                      Total: {filteredData.total}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Grid>

            <Box sx={style.createJob}>
              <Button
                variant="contained"
                type="button"
                color="success"
                sx={style.jobButtons}
              >
                Send Statement
              </Button>
            </Box>
          </>
        )}
      </Grid>
    </>
  );
};

export default CustomerStatement;
